// This file handles overrides of geo-political discrepency in ISO 3166 codes.
// See: https://www.notion.so/watershedclimate/Handling-ambiguities-in-ISO-3166-standard-6698072795bd4eaa959f2554f556026e

import subdivisionOverrides from '../generated/shared_data/geo/subdivision_overrides.json';
import countryOverrides from '../generated/shared_data/geo/country_overrides.json';

// mappings of overrides
export const SUBDIVISION_OVERRIDES: Record<string, OverrideOutput> =
  subdivisionOverrides;
export const COUNTRY_OVERRIDES: Record<string, OverrideOutput> =
  countryOverrides;

// arrays of items to override. used in form validation, so exported as consts
const COUNTRIES_TO_ENSURE_NULL_SUBDIVISION = new Set(
  Object.values(SUBDIVISION_OVERRIDES)
    .filter((so) => !so.hasFurtherSubdivisions)
    .map((so) => so.country)
);

type OverrideOutput = {
  country: string;
  subdivision: string | null;
  hasFurtherSubdivisions?: boolean;
};

export function getIso3166Override({
  country,
  subdivision,
}: {
  country?: string;
  subdivision?: string;
}): OverrideOutput | undefined {
  if (subdivision) {
    const override = SUBDIVISION_OVERRIDES[subdivision];
    if (override) {
      return override;
    }
  }

  if (country) {
    const override = COUNTRY_OVERRIDES[country];
    if (override) {
      return override;
    }
    // countries that are overridden subdivisions must have a null subdivision
    if (COUNTRIES_TO_ENSURE_NULL_SUBDIVISION.has(country)) {
      return { country, subdivision: null };
    }
  }
}
